/*
 * Scentt view redirect \u2013 used by sections/main-page.liquid on the pages with handle "compare" and "brands".
 * <scentt-view-redirect data-view="compare|brands"> reloads the same page with ?view=<view> so Shopify
 * renders templates/page.<view>.json even when the page was given the default template (and before the
 * theme is published). Only a relative "?\u2026" URL is used \u2013 never a path built from location.pathname.
 * If ?view is already set (the template is missing) it stays put and shows its fallback link.
 */
(() => {
  const VIEWS = ['compare', 'brands'];
  class ScenttViewRedirect extends HTMLElement {
    connectedCallback() {
      const view = this.dataset.view;
      if (!VIEWS.includes(view) || (window.Shopify && window.Shopify.designMode)) return;
      let params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      if (params.get('view') === view) return; /* already asked for it: avoid a redirect loop */
      params.set('view', view);
      window.location.replace(`?${params.toString()}${window.location.hash}`);
    }
  }
  if (!customElements.get('scentt-view-redirect')) customElements.define('scentt-view-redirect', ScenttViewRedirect);
})();
